import React from "react";
import Group400 from "../Group400";
import "./custom-step-data.css";

const CustomClearanceStepData = () => {
  return <Group400 />;
};

export default CustomClearanceStepData;
